var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIBilling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.551 11.92c2.674 0 4.837-2.168 4.837-4.839 0-2.672-2.164-4.837-4.837-4.837-2.671 0-4.837 2.165-4.837 4.837 0 2.671 2.167 4.839 4.837 4.839z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.853 11.852c2.713 0 4.915-2.201 4.915-4.914 0-2.714-2.202-4.915-4.915-4.915-2.715 0-4.912 2.202-4.912 4.915-0 2.713 2.197 4.914 4.912 4.914z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.764 39.458c-6.36 0-11.516 5.155-11.516 11.515 0 6.36 5.156 11.516 11.516 11.516s11.516-5.156 11.516-11.516c0-6.359-5.156-11.515-11.516-11.515zM14.129 58.283v1.84h-2.753v-1.84c-2.936-0.336-4.809-3.131-4.809-4.958h2.935c0 0.821 0.633 1.912 1.901 2.173v-3.45c-0.633-0.122-0.987-0.222-1.666-0.408-1.735-0.479-2.936-1.94-2.936-3.802 0-1.845 1.801-3.915 4.576-4.282v-1.719h2.753v1.719c2.943 0.379 4.753 2.553 4.753 4.726l-2.875-0.001c-0.002-0.95-0.792-1.813-1.878-1.919v3.236c0.799 0.176 0.799 0.156 1.533 0.356 2.738 0.745 3.355 2.537 3.355 4.040-0.001 2.308-1.846 3.892-4.889 4.29z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.376 49.092c-1.23-0.219-1.571-0.745-1.571-1.313 0-0.663 0.834-1.302 1.571-1.388v2.701zM14.162 55.485v-2.916c1.215 0.174 1.985 0.697 1.985 1.448 0 0.664-0.717 1.42-1.985 1.468z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.238 20.3h1.907l-2.204 8.203h13.219l-2.204-8.203h1.907l2.259 8.203h4.253l-2.729-9.95c-0.728-2.406-3.109-4.959-6.229-4.959h-7.736c-3.123 0-5.503 2.552-6.232 4.959l-2.726 9.95h4.253l2.261-8.203z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.104 13.545c2.414 0 4.373 1.956 4.373 4.369l-0.007 13.414h2.815v5.499l-5.696 0.003v22.774c0 1.592-1.306 2.883-2.899 2.883-1.589 0-2.881-1.291-2.881-2.883 0-2.175 0-19.996 0-22.772h-1.837c0 2.778 0 20.597 0 22.772 0 1.592-1.293 2.883-2.886 2.883-1.592 0-2.895-1.291-2.895-2.883 0-1.23 0-12.381 0-22.77l-42.945 0.013v-5.519h42.945c0-7.186 0-12.915 0-12.915l-9.174 10.862c-1.93 2.229-5.367-0.555-3.43-2.939l9.506-11.421c0.615-0.612 1.166-1.37 3.436-1.37h11.573z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIBilling);
export default __webpack_public_path__ + "static/media/i-billing.a38d3a29.svg";
export { ForwardRef as ReactComponent };